export default function ReferFacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
    >
      <mask
        id="mask0_10402_5131"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="37"
        height="37"
      >
        <path
          d="M8.87613 0.000976562H28.5835C30.7342 0.00718913 32.7951 0.869704 34.3159 2.40009C35.8366 3.93048 36.6937 6.00435 36.6999 8.16864V27.8358C36.693 29.9996 35.8355 32.0727 34.3148 33.6024C32.7941 35.1322 30.7337 35.9943 28.5835 36.0005H8.87613C6.72594 35.9943 4.66554 35.1322 3.14484 33.6024C1.62415 32.0727 0.76671 29.9996 0.759766 27.8358V8.16864C0.765939 6.00435 1.62304 3.93048 3.14381 2.40009C4.66459 0.869704 6.72544 0.00718913 8.87613 0.000976562Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_10402_5131)">
        <mask
          id="mask1_10402_5131"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="37"
          height="37"
        >
          <path
            d="M36.6999 0.000976562H0.759766V36.0005H36.6999V0.000976562Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_10402_5131)">
          <rect
            width="36.5017"
            height="36.3086"
            transform="matrix(1 0 0 -1 0.558594 36.1597)"
            fill="#8065C9"
          />
        </g>
        <path
          d="M25.7261 23.2295L26.5216 18.0021H21.526V14.6085C21.526 13.1781 22.2221 11.7859 24.4509 11.7859H26.7322V7.33562C25.402 7.11934 24.0579 7.0013 22.7106 6.98242C18.6158 6.98242 15.9221 9.48423 15.9221 14.0169V18.0021H11.3594V23.2295H15.9221V36.0534H21.526V23.2295H25.7261Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
